var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _polygon, _polygon2, _rect9, _path4, _polygon3, _path5, _polygon4, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b80448b0-14d5-4ee1-8d6b-75eb9311be00",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 909.75363,
    height: 730.11005,
    viewBox: "0 0 909.75363 730.11005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M524.87682,274.72109C524.82114,169.855,439.76535,84.88938,334.89925,84.945c-104.866.05568-189.83171,85.11152-189.776,189.97757A189.87571,189.87571,0,0,0,160.41359,349.473c-.18569-.20645-.37749-.40733-.56227-.61459a190.04331,190.04331,0,0,0,34.58226,53.51326c.04313.04755.08747.0938.13081.14135,1.16647,1.2713,2.33957,2.536,3.53985,3.775a189.30014,189.30014,0,0,0,133.92246,58.2722l-6.41612,348.49291h19.82225L341.421,583.04373l28.67385-15.09626-4.37418-8.30838-24.483,12.88971-1.88354-107.986A189.87429,189.87429,0,0,0,524.87682,274.72109Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M689.06193,579.96366h363.6747V395.855H689.06193Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.87682,582.10385H686.92174V393.71478h367.95508Zm-365.81489-2.14019h363.6747V395.855H689.06193Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 609.23333,
    y: 372.86379,
    width: 37.04675,
    height: 3.08721,
    fill: "#6c63ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 658.62898,
    y: 372.86379,
    width: 37.0467,
    height: 3.08721,
    fill: "#6c63ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 730.40696,
    y: 401.42065,
    width: 37.0467,
    height: 3.08721,
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 780.57444,
    y: 401.42065,
    width: 37.0467,
    height: 3.08721,
    fill: "#6c63ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 708.7964,
    y: 372.86379,
    width: 108.82474,
    height: 3.08721,
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 609.23333,
    y: 401.42065,
    width: 108.82474,
    height: 3.08721,
    fill: "#6c63ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 609.23333,
    y: 429.97751,
    width: 108.82474,
    height: 3.08721,
    fill: "#6c63ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 741.98409,
    y: 429.97751,
    width: 75.63704,
    height: 3.08721,
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "598.821 385.897 585.787 372.864 598.821 359.83 601.428 362.438 591.002 372.864 601.428 383.289 598.821 385.897",
    fill: "#6c63ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "852.732 446.098 850.124 443.491 860.55 433.064 850.124 422.638 852.732 420.031 865.765 433.064 852.732 446.098",
    fill: "#6c63ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 968.73277,
    y: 515.77985,
    width: 26.61292,
    height: 3.68815,
    transform: "translate(56.71628 1222.37757) rotate(-73.13998)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M671.43981,815.055h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#ccc"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.222 717.182 404.962 717.181 411.022 668.043 392.22 668.044 392.222 717.182",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M534.09584,797.96765l25.08866-.001h.001a15.98933,15.98933,0,0,1,15.98846,15.9882v.51957l-41.07738.00152Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.001 708.456 315.368 711.517 333.057 665.274 314.805 660.757 303.001 708.456",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M445.96931,788.58318l24.354,6.02686.001.00025a15.98931,15.98931,0,0,1,11.67876,19.3613l-.12483.50434-39.8745-9.86786Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M495.25149,593.64631l-11.202,63.76551s-4.30848,7.75526-2.58509,11.202,2.58509,3.44678,0,5.17017-6.03187,0-5.17017,4.30848a43.98385,43.98385,0,0,1,.86169,7.75527L453.02838,768.5706s-15.51052,6.89357-4.30848,11.202,22.4041,7.75527,24.98919,3.44679,0-9.47866,0-9.47866l39.638-94.78656s6.03187-8.617,6.03187-13.78714,19.819-42.2231,19.819-42.2231.86169,37.05293,1.72339,39.638-1.72339,7.75526-1.72339,11.202-1.7234,3.44679,0,5.17018,1.72339,21.5424,1.72339,21.5424-10.34035,76.69094-4.30848,77.55264,23.26579-.8617,23.26579-4.30848a4.29957,4.29957,0,0,0-2.58509-4.30848l11.202-65.4889s-.8617-4.30848.8617-7.75526,1.72339-3.44678,1.72339-5.17018-.8617-2.58508,0-3.44678a4.25464,4.25464,0,0,0,.86169-2.58509s-1.72339-5.17017-.86169-6.03187,19.819-65.4889,13.78713-73.24416S495.25149,593.64631,495.25149,593.64631Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 388.66678,
    cy: 348.69393,
    r: 22.4041,
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M517.96076,449.86326c1.152-.77252,1.19661-2.5403.81046-3.97462s-1.08809-2.84471-1.02791-4.30366c.165-3.99778,5.67106-5.60137,5.98562-9.57957.19348-2.44665-1.7052-5.15207-.60955-7.27048.69191-1.33776,2.30106-1.78388,3.76637-2.04074a46.79642,46.79642,0,0,1,17.16479.23051l.82545-2.16845,4.19337,2.76684c.229-1.34571,2.09172-1.48067,3.30912-.8348s2.27133,1.76123,3.59976,1.97656c2.11732.34323,3.791-1.94977,3.67922-4.1561s-1.458-4.205-2.86731-5.94764a47.16544,47.16544,0,0,0-12.633-10.93575l1.16367-2.09676-2.492,1.00075-.27334-2.50769-2.4278,1.36452-.03457-2.25861c-2.5993,2.98467-7.126,2.88184-11.09947,3.151a31.95151,31.95151,0,0,0-18.2549,6.787A24.27232,24.27232,0,0,0,501.8549,426.512c-.22559,5.27084,1.59146,11.686,5.48322,15.59449C510.87554,445.6592,516.1167,443.50325,517.96076,449.86326Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M588.764,651.01a10.6681,10.6681,0,0,1,.91947-16.33239l-5.9756-23.63473,13.47708-7.1344,7.96993,33.49534A10.72591,10.72591,0,0,1,588.764,651.01Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M552.74432,620.42325c-27.23335.00209-52.30133-12.3238-52.63971-12.493l-.28111-.14056-2.28537-54.8462c-.6627-1.93814-13.71246-40.18185-15.9226-52.33751-2.2393-12.31547,30.215-23.12385,34.15608-24.38783l.89437-9.90725,36.36909-3.919,4.60951,12.67676,13.04768,4.89245a6.45375,6.45375,0,0,1,3.99991,7.5818L567.44043,517.033l14.26428,97.56747-.36623.165A69.242,69.242,0,0,1,552.74432,620.42325Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M585.25848,626.54481l-12.62132-51.95852-13.67992-62.69975,6.94408-31.24966h5.93675c.1088,0,10.89714.16139,13.22,14.09744,2.24971,13.49824,9.034,56.45689,9.10217,56.889l11.46614,73.3837Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#6c63ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M531.252,617.76424a10.66811,10.66811,0,0,0-13.02465-9.897l-14.10771-19.88166-14.173,5.62644,20.31717,27.79694a10.72591,10.72591,0,0,0,20.98822-3.6447Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M503.75652,616.29085l-42.68769-55.37876,15.9947-50.2687c1.1721-12.63824,9.08056-16.16728,9.41712-16.31148l.5133-.22021,13.91835,37.11665L490.693,558.47992,515.776,600.666Z",
    transform: "translate(-145.12318 -84.94497)",
    fill: "#6c63ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutme);
export default __webpack_public_path__ + "static/media/aboutme.79439da1f0d3645ccd4ecb1e729afef4.svg";
export { ForwardRef as ReactComponent };